import {
  FleetVehicleContractSaleEditFormValues,
  FleetVehicleContractRentEditFormValues,
  FleetVehicleContractSaleSearchFormValues,
  FleetVehicleContractRentSearchFormValues,
} from "./types";

export const ContractSaleStatusId = {
  Draft: "draft",
  Created: "created",
  Sent: "sent",
  Signed: "signed",
  Invoiced: "invoiced",
  Cancelled: "cancelled",
} as const;

export type ContractSaleStatusIdType = typeof ContractSaleStatusId[keyof typeof ContractSaleStatusId];

/*-------------------------------------------------------------------------------------------
  VEHICLE CONTRACT SALE SEARCH
---------------------------------------------------------------------------------------------*/
export const initialFleetVehicleContractSaleSearchForm: FleetVehicleContractSaleSearchFormValues =
{
  search: null,
  contractSaleStatusId: null,
  contractDateFrom: null,
  contractDateTo: null,
  sellingPriceMin: null,
  sellingPriceMax: null,
  contactClientId: null,
};




export const initialFleetVehicleContractSaleEditForm: FleetVehicleContractSaleEditFormValues =
{
  vehicleId: null,
  contractNumber: null,
  contractDate: new Date(),
  offerSaleId: null,
  sellerCompanyName: null,
  sellerHeadquartersAddress: null,
  sellerPhoneNumber: null,
  sellerPersonalIdentificationNumber: null,
  sellerSalesPersonName: null,
  sellerTransactionAccountNumber: null,
  buyerContactId: null,
  buyerContactTypeId: null,
  buyerName: null,
  buyerAddress: null,
  buyerPersonalIdentificationNumber: null,
  buyerPhoneNumber: null,
  buyerMobilePhoneNumber: null,
  buyerEmail: null,
  buyerAuthorizedRepresentativeName: null,
  depositAmount: 0,
  deliveryTime: null,
  placeOfVehicleDelivery: null,
  tradeInVehicleId: null,
  contractSaleTemplateId: null,
  contractSaleStatusId: null,
  createdOn: null,
};


/*-------------------------------------------------------------------------------------------
  CONTRACT RENT STATUS
---------------------------------------------------------------------------------------------*/
export const ContractRentStatusId = {
  Draft: "draft",
  Created: "created",
  Sent: "sent",
  Signed: "signed",
  Invoiced: "invoiced",
  Cancelled: "cancelled",
} as const;

export type ContractRentStatusIdType = typeof ContractRentStatusId[keyof typeof ContractRentStatusId];

/*-------------------------------------------------------------------------------------------
  VEHICLE CONTRACT RENT SEARCH
---------------------------------------------------------------------------------------------*/
export const initialFleetVehicleContractRentSearchForm: FleetVehicleContractRentSearchFormValues =
{
  search: null,
  contractRentStatusId: null,
  contractDateFrom: null,
  contractDateTo: null,
  sellingPriceMin: null,
  sellingPriceMax: null,
  contactClientId: null,
};

/*-------------------------------------------------------------------------------------------
  VEHICLE CONTRACT RENT
---------------------------------------------------------------------------------------------*/
export const initialFleetVehicleContractRentEditForm: FleetVehicleContractRentEditFormValues =
{
  vehicleId: null,
  contractNumber: null,
  contractDate: new Date(),
  offerRentId: null,
  lessorCompanyName: null,
  lessorHeadquartersAddress: null,
  lessorPhoneNumber: null,
  lessorPersonalIdentificationNumber: null,
  lessorSalesPersonName: null,
  lessorTransactionAccountNumber: null,
  lesseeContactId: null,
  lesseeContactTypeId: null,
  lesseeName: null,
  lesseeAddress: null,
  lesseePersonalIdentificationNumber: null,
  lesseePhoneNumber: null,
  lesseeMobilePhoneNumber: null,
  lesseeEmail: null,
  lesseeAuthorizedRepresentativeName: null,
  depositAmount: 0,
  deliveryTime: null,
  rentStartDate: null,
  rentEndDate: null,
  rentDurationMonths: null,
  monthlyPrice: null,
  placeOfVehicleDelivery: null,
  contractRentTemplateId: null,
  contractRentStatusId: null,
  createdOn: null,
};
